module.exports = __webpack_public_path__ + "src/img/app.62746106.svg";